import type React from 'react';
import { useEffect, useRef, useState } from 'react';

type UseAccordionPanelParams = Readonly<{
  children: React.ReactNode;
  isActive: boolean;
}>;

export type UseAccordionPanelReturn = Readonly<{
  maxHeight: number;
  sectionRef: React.RefObject<HTMLElement>;
}>;

/**
 * Aísla la animación de altura del panel: mide el `scrollHeight` real del
 * contenido tras el montaje (y cuando `children` cambia) para poder animar de
 * `0` a la altura medida vía `max-height`. Mientras no esté medido o el panel
 * no esté activo, la altura resuelta es `0`.
 */
function useAccordionPanel({ children, isActive }: UseAccordionPanelParams): UseAccordionPanelReturn {
  const sectionRef = useRef<HTMLElement>(null);
  const [isMeasured, setIsMeasured] = useState(false);
  const [measuredHeight, setMeasuredHeight] = useState<number>(0);

  useEffect(() => {
    const height = sectionRef.current?.scrollHeight ?? 0;
    setIsMeasured(true);
    setMeasuredHeight(height);
  }, [children]);

  const maxHeight = isActive && isMeasured ? measuredHeight : 0;

  return { maxHeight, sectionRef };
}

export default useAccordionPanel;
